/**
 * Dashboard Hooks
 */
import { useApiQuery } from './useApiQuery';
import { dashboardService } from '../services/dashboardService';
import { queryTags } from '../queryTags';
import type { GetRevenueGraphParams, GetUserGraphParams, GetSubscriptionGraphParams } from '../types/dashboard.types';
import type { UseQueryOptions } from '@tanstack/react-query';

/**
 * Get revenue graph data hook
 */
export function useGetRevenueGraph(
    params: GetRevenueGraphParams,
    options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
    return useApiQuery({
        queryKey: [queryTags.dashboard, 'revenue-graph', params.type],
        queryFn: () => dashboardService.getRevenueGraph(params),
        ...options,
    });
}

/**
 * Get user graph data hook
 */
export function useGetUserGraph(
    params: GetUserGraphParams,
    options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
    return useApiQuery({
        queryKey: [queryTags.dashboard, 'user-graph', params.type],
        queryFn: () => dashboardService.getUserGraph(params),
        ...options,
    });
}

/**
 * Get subscription graph data hook
 */
export function useGetSubscriptionGraph(
    params: GetSubscriptionGraphParams,
    options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
    return useApiQuery({
        queryKey: [queryTags.dashboard, 'subscription-graph', params.type],
        queryFn: () => dashboardService.getSubscriptionGraph(params),
        ...options,
    });
}

/**
 * Get dashboard stats hook
 */
export function useGetDashboardStats(
    options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
    return useApiQuery({
        queryKey: [queryTags.dashboard, 'stats'],
        queryFn: () => dashboardService.getDashboardStats(),
        ...options,
    });
}
